
import { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useLocation } from "react-router-dom"
import styled from "styled-components"
import Btn from "../../shared/button/Btn"
import { showModal, showNestedModal } from "../../../features/modal/modalSlice"
import { useScrollLock } from "../../../hooks/useScrollLock"
import { IoStar } from "react-icons/io5";
import { setPhotoList } from "../../../features/loadOwner/loadOwnerSlice"
import moment from "moment"

const ModalContainer = styled.div`
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0,0,0,0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 26;

    .modal{
        width: 1400px;
        height: auto;
        color: ${({ theme }) => theme.mainTextColor};
        background-color: ${({ theme }) => theme.mainBgColor};
        border: 1px solid;
        border-color: ${({ theme }) => theme.mainBorderColor};
        padding-top: 20px;
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        align-items: center;
        max-height: 1000px;
        overflow: auto;

        .content{
            display: flex;
            gap: 40px;
            width: 100%;
            color: ${({theme}) => theme.mainTextColor};

            .left-side-container{
                display: flex;
                flex-direction: column;
                width: calc(55% - 40px);

                .left-top-container{
                    display: flex;
                    align-items: center;
                    gap: 20px;
                    padding: 30px;
                    padding-bottom: 20px;

                    .logo-img-wrapper{
                        border: 1px solid ${({theme}) => theme.mainTextColor};
                        min-height: 80px;
                        display: flex;
                        align-items: center;
                        border-radius: 5px;
                        
                        .logo-img{
                            width: 180px;
                        }
                    }

                    .left-top-content-container{
                        display: flex;
                        flex-direction: column;
                        gap: 8px;

                        .rating-container{
                            display: flex;
                            gap: 5px;
                            background-color: var(--color-main);
                            color: #fff;
                            padding: 5px 10px;
                            border-radius: 5px;
                            display: flex;
                            align-items: center;
                            width: min-content;
                            font-size: var(--font-size-sm);
                            font-weight: var(--font-weight-md);
                            
                            .star-icon{
                                font-size: 1rem;
                            }
                        }

                        .company-name{
                            font-size: var(--font-size-sm);
                            font-weight: var(--font-weight-lg);
                        }
                    }
                }

                .left-load-list-container{
                    display: flex;
                    flex-direction: column;
                    border: 1px solid ${({theme}) => theme.mainBorderColor};
                    border-left: none;

                    .load-list-top{
                        width: 100%;
                        padding: 10px 0;
                        background-color: ${({theme}) => theme.secondaryBgColor} !important;

                        h3{
                            font-size: var(--font-size-sm);
                            font-weight: var(--font-weight-lg);
                            padding-left: 30px;
                        }
                    }

                    .load-list-filter-container{
                        display: flex;
                        gap: 20px;
                        padding: 20px;
                        padding-left: 30px;

                        .filter-item{
                            font-size: var(--font-size-sm);
                            font-weight: var(--font-weight-lg);
                            border: 1px solid ${({theme}) => theme.mainTextColor};
                            padding: 5px;
                            border-radius: 5px;
                            cursor: pointer;

                        }
                    }

                    .no-yuk-text{
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        min-height: 300px;
                        font-size: var(--font-size-md);
                        font-weight: var(--font-weight-lg);
                    }

                    .load-list{
                        display: flex;
                        flex-direction: column;
                        width: 100%;
                        max-height: 400px;
                        overflow: auto;

                        &::-webkit-scrollbar {
                            width: 0;
                            width: 8px;
                        }
                        &::-webkit-scrollbar-thumb {
                            background-color: ${({theme})=> theme.scrollThumbColor};
                            border-radius: 10px;
                        }
                        &::-webkit-scrollbar-track {
                            background-color: transparent;
                        }


                        .load-item{
                            width: 100%;
                            padding: 15px 30px;
                            padding-right: 0;
                            border-bottom: 1px solid ${({theme}) => theme.mainBorderColor};
                            display: flex;
                            align-items: center;

                            &:hover{
                                background-color: ${({theme}) => theme.secondaryBgColor};
                            }

                            .item-status{
                                width: 15px;
                                height: 15px;
                                border-radius: 50%;
                                background-color: var(--color-main);
                                margin-right: 30px;
                            }
                            
                            .item-content-container{
                                display: flex;
                                flex-direction: column;
                                gap: 8px;
                                width: max-content;

                                .content-item{
                                    font-size: var(--font-size-sm);
                                    font-weight: var(--font-weight-md);


                                }

                                .content-item-grp{
                                    display: flex;
                                    gap: 40px;

                                    div{
                                        width: 150px;
                                    }

                                }


                            }


                            &:first-child{
                                border-top: 1px solid ${({theme}) => theme.mainBorderColor};
                            }

                            &:last-child{
                                border-bottom: none;
                            }
                        }
                    }
                }
            }

            .right-side-container{
                display: flex;
                flex-direction: column;
                width: 45%;

                .right-top-container{
                    display: flex;
                    justify-content: flex-end;
                    gap: 30px;
                    padding: 30px;
                    padding-bottom: 20px;
                    width: 100%;
                    margin-top: 43px;

                    .right-top-item{
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        gap: 5px;
                        font-size: var(--font-size-sm);
                        font-weight: var(--font-weight-lg);


                    }

                }

                .company-doc-container{
                    display: flex;
                    flex-direction: column;

                    .company-doc-top{
                        width: 100%;
                        padding: 10px 0;
                        background-color: ${({theme}) => theme.secondaryBgColor} !important;

                        h3{
                            font-size: var(--font-size-sm);
                            font-weight: var(--font-weight-lg);
                            padding-left: 30px;
                        }
                    }

                    .company-doc-list{
                        display: flex;
                        flex-wrap: wrap;
                        border: 1px solid ${({theme}) => theme.mainBorderColor};
                        padding: 20px;


                        .company-doc-item{
                            padding-right: 25px;

                            img{
                                width: 170px;
                                height: 150px;
                                object-fit: cover;
                            }
                        }
                    }
                }
            }

        }

        .button-grp{
            width: 100%;
            display: flex;
            justify-content: center;
            margin-top: auto;
            margin: 30px 0;
        }
    }
`

const filterList = [
    {
        id: 1,
        text: "Tümü",
        quantity: 1071 
    },
    {
        id: 2,
        text: "Ankara",
        quantity: 141 
    },
    {
        id: 3,
        text: "İstanbul",
        quantity: 141 
    },
    {
        id: 4,
        text: "Balıkesir",
        quantity: 1071 
    },
    {
        id: 5,
        text: "Afyonkarahisar",
        quantity: 333 
    },
]

const LoadOwnerProfileModal = () => {

    const location = useLocation()
    const dispatch = useDispatch()

    const {modalLocation } = useSelector(state => state.modal)
    const {loadOwnerProfileData} = useSelector(state => state.loadOwner)
    const { lockScroll, unlockScroll } = useScrollLock();

    //! bu modal açıldığnda ekran ı lock lamak için
    useEffect(() => {
        lockScroll()

        return () => {
            unlockScroll()
        }
    }, [lockScroll, unlockScroll])

    //! bu başka bir sayfaya geçildiğinde modal ı kapatmak için
    useEffect(() => {
        if (location.pathname !== modalLocation) {
            dispatch(showModal(null))
        }
    }, [dispatch, location.pathname, modalLocation])

    const handleBundlePhotos = ({currentPhotoItemId}) => {
        if(loadOwnerProfileData.companyDoc.logo1 || loadOwnerProfileData.companyDoc.logo2 || loadOwnerProfileData.companyDoc.vergiLevhasi || loadOwnerProfileData.companyDoc.kase || loadOwnerProfileData.companyDoc.faturaBaslik){
            const photoList = [
                `${process.env.REACT_APP_API_IMG_COMPANY_URI}${loadOwnerProfileData.companyDoc.logo1}`,
                `${process.env.REACT_APP_API_IMG_COMPANY_URI}${loadOwnerProfileData.companyDoc.logo2}`,
                `${process.env.REACT_APP_API_IMG_COMPANY_URI}${loadOwnerProfileData.companyDoc.vergiLevhasi}`,
                `${process.env.REACT_APP_API_IMG_COMPANY_URI}${loadOwnerProfileData.companyDoc.kase}`,
                `${process.env.REACT_APP_API_IMG_COMPANY_URI}${loadOwnerProfileData.companyDoc.faturaBaslik}`
            ]

            const formattedPhotoList = photoList.map((item, i) => {
                return {
                    id: i+1,
                    photo: item
                }
            })

            dispatch(showNestedModal("loadOwnerImage"))
            dispatch(setPhotoList({
                photoList: formattedPhotoList,
                currentPhotoItemId
            }))
        }
    } 


  return (loadOwnerProfileData?.companyDoc && loadOwnerProfileData?.companyInfo && loadOwnerProfileData?.companyLoads) && (
    <ModalContainer>
    <div className="modal" onClick={(e) => e.stopPropagation()}>
        <div className="content">
            {/* //! left side */}
            <div className="left-side-container">
                <div className="left-top-container">
                    <div className="logo-img-wrapper">
                        <img className="logo-img" src={`${process.env.REACT_APP_API_IMG_COMPANY_URI}${loadOwnerProfileData?.companyDoc?.logo1}`} alt="" />
                    </div>
                    <div className="left-top-content-container">
                        <div className="rating-container">
                            <IoStar className="star-icon"/>
                            <span>4.3</span>
                        </div>
                        <div className="company-name">{loadOwnerProfileData?.companyInfo?.companyName}</div>
                        <div className="company-name">{loadOwnerProfileData?.companyInfo?.companyPhoneNumber}</div>
                    </div>
                </div>
                <div className="left-load-list-container">
                    <div className="load-list-top">
                        <h3>Firma Yükleri</h3>
                    </div>

                    {
                        loadOwnerProfileData?.companyLoads?.nonAspiredLoads?.items?.$values.length > 0 ?
                        <div className="load-list-filter-container">
                            {
                                filterList.map(item => (
                                    <div className="filter-item" key={item.id}>{item.text}({item.quantity})</div>
                                ))
                            }
                        </div>
                        :
                        <div className="no-yuk-text">Yük Bulunamadı</div>
                        }
                    <div className="load-list">
                        {
                            loadOwnerProfileData?.companyLoads?.nonAspiredLoads?.items?.$values?.map(item => {
                                return (
                                    <div className="load-item" key={item.id}>
                                        <div className="item-status"/>
                                        <div className="item-content-container">
                                            <div className="content-item" >{item.senderAdressCity}-{item.senderAdressTown}/{item.receiverCity}-{item.receiverAdressTown}</div>
                                            <div className="content-item content-item-grp">
                                                <div>{item.planningLoadDate}</div>
                                                <div>{item.loadType}</div>
                                                <div>{item.loadUnitId === 3 ? "Basar Tonaj" : `${item.loadQuantity} ${item.loadUnit}`}</div>
                                            </div>
                                        </div>
                                        <Btn bgColor="#E85446" color="#fff" width={"90px"} height="32px" fontSize="14px" fontWeight="500">Teklif Ver</Btn>
                                    </div>
                                )
                            })
                        }
                    </div>
                </div>
            </div>


            {/* //! right side */}
            <div className="right-side-container">
                <div className="right-top-container">
                    <div className="right-top-item">
                        <div>Kamyoon'daki Süresi</div>
                        <div>{moment().diff(moment(loadOwnerProfileData?.companyInfo.createdAt, 'YYYY-MM-DD'), 'months')} Ay</div>
                    </div>
                    <div className="right-top-item">
                        <div>Toplam Verilen Yük</div>
                        <div>36</div>
                    </div>
                </div>
                <div className="company-doc-container">
                    <div className="company-doc-top">
                        <h3>Belgeler ve Fotoğraflar</h3>
                    </div>

                    <div className="company-doc-list">
                        <div className="company-doc-item" onClick={() => handleBundlePhotos({currentPhotoItemId: 1})}>
                            <img src={`${process.env.REACT_APP_API_IMG_COMPANY_URI}${loadOwnerProfileData.companyDoc.logo1}`} alt="" />
                        </div>
                        <div className="company-doc-item" onClick={() => handleBundlePhotos({currentPhotoItemId: 2})}>
                            <img src={`${process.env.REACT_APP_API_IMG_COMPANY_URI}${loadOwnerProfileData.companyDoc.logo2}`} alt="" />
                        </div>
                        <div className="company-doc-item" onClick={() => handleBundlePhotos({currentPhotoItemId: 3})}>
                            <img src={`${process.env.REACT_APP_API_IMG_COMPANY_URI}${loadOwnerProfileData.companyDoc.vergiLevhasi}`} alt="" />
                        </div>
                        <div className="company-doc-item" onClick={() => handleBundlePhotos({currentPhotoItemId: 4})}>
                            <img src={`${process.env.REACT_APP_API_IMG_COMPANY_URI}${loadOwnerProfileData.companyDoc.kase}`} alt="" />
                        </div>
                        <div className="company-doc-item" onClick={() => handleBundlePhotos({currentPhotoItemId: 5})}>
                            <img src={`${process.env.REACT_APP_API_IMG_COMPANY_URI}${loadOwnerProfileData.companyDoc.faturaBaslik}`} alt="" />
                        </div>
                    </div>
                </div>

            </div>
        </div>
        <div className='button-grp'>
            <Btn color={"#E85446"} bgColor={"transparent"} borderColor="#E85446" width="220px" radius={"10px"} handleClick={()=> dispatch(showModal(null))}>Geri Dön</Btn>
        </div>
    </div>
</ModalContainer>
  )
}

export default LoadOwnerProfileModal